import React, { useCallback, useEffect, useState } from "react";
import { Container } from "reactstrap";
import { useParams } from "react-router";
import { Spin } from "antd";
import { getBundleAssignments, getBundleAssignmentsLogs, getBundleDetails, getCustomerGroups } from "utils/api";
import { defaultNgiErrorMethod } from "components/Common/responses/message";
import DataTabs from "pages/price-management/Bundles/bundleDetails/DataTabs";
import Header from "pages/price-management/Bundles/bundleDetails/Header";
import { extractPromisesResult } from "utils/helpers/functions";
import { getDictionary } from "store/dictionaries/actions";
import { DICTIONARY_TYPES } from "store/dictionaries/constants";
import { useDispatch } from "react-redux";
import MetaData from "components/VerticalLayout/MetaData";

const AVAILABLE_STATUSES = ["Active", "Draft"];
const DEFAULT_STATE = {
  customer: {
    active: [],
    pending: [],
  },
  other: {
    active: [],
    pending: [],
  },
};
const BundleDetails = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const [data, setData] = useState(null);
  const [assignments, setAssignments] = useState([]);
  const [assignmentsGroups, setAssignmentsGroups] = useState(DEFAULT_STATE);
  const [logs, setLogs] = useState({});
  const [customerGroupList, setCustomerGroupListList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const getData = useCallback(() => {
    setIsLoading(true);
    setAssignmentsGroups(DEFAULT_STATE);
    Promise.allSettled([getBundleDetails(id), getBundleAssignments(id), getBundleAssignmentsLogs(id)])
      .then(res => {
        const [bundleDetails, bundleAssignments, bundleAssignmentsLogs] = extractPromisesResult(res);
        setData(bundleDetails?.data?.result);
        setAssignments(bundleAssignments?.data?.result?.items);
        const pending = bundleAssignments?.data?.result?.items?.filter(
          item => item.status === "Pending" && item.type !== "Customer"
        );
        const active = bundleAssignments?.data?.result?.items?.filter(
          item => item.status === "Active" && item.type !== "Customer"
        );

        const pendingCustomer = bundleAssignments?.data?.result?.items?.filter(
          item => item.status === "Pending" && item.type === "Customer"
        );
        const activeCustomer = bundleAssignments?.data?.result?.items?.filter(
          item => item.status === "Active" && item.type === "Customer"
        );
        setAssignmentsGroups({
          customer: {
            pending: pendingCustomer,
            active: activeCustomer,
          },
          other: {
            pending,
            active,
          },
        });
        setLogs(bundleAssignmentsLogs?.data?.result?.items);
        setIsLoading(false);
      })
      .catch(e => {
        defaultNgiErrorMethod(e);
        setIsLoading(false);
      });
  }, [id]);

  useEffect(() => {
    getData();
    dispatch(getDictionary(DICTIONARY_TYPES.DEPOT));
    getCustomerGroups({ pageSize: 1000 }).then(res => {
      setCustomerGroupListList(
        res?.data?.result?.items?.filter(item => AVAILABLE_STATUSES.includes(item.status)) || null
      );
    });
  }, []);

  return (
    <>
      <div className="page-content">
        <Container fluid>
          <MetaData pageTitle={data?.name || "Bundle Details"} />

          <Spin spinning={isLoading}>
            <Header data={data} />
            <DataTabs
              customerGroupList={customerGroupList}
              assignments={assignments}
              assignmentsGroups={assignmentsGroups}
              data={data}
              logs={logs}
              update={getData}
              setIsLoading={setIsLoading}
            />
          </Spin>
        </Container>
      </div>
    </>
  );
};

export default BundleDetails;
